
<template>
  <!--里程碑模块-->
  <div class="milestone_box">
    <div class="milestone">
      <!-- 导航箭头 -->
<!--      <div class="milestone_arrow left"></div>-->
<!--      <div class="milestone_arrow right"></div>-->

      <!-- 山脉背景 -->
      <div class="milestone_mountain"></div>

      <!-- 时间节点 (2009-2024) -->
      <div class="milestone_white2009" data-tooltip="2009-2015年：台球俱乐部运营">
        2009
      </div>

      <div class="milestone_white2016" data-tooltip="2016年：璟点台球器材超市全国连锁项目启动，且璟点首家连锁器材店落户山西太原。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2016
      </div>

      <div class="milestone_white2017"
           data-tooltip="2017年：中国区全权代理环球品牌，同时璟点全国器材连锁店突破 50 家。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2017
      </div>

      <div class="milestone_white2018" data-tooltip="2018年：中国区全权代理美洲豹品牌，启动京东、天猫旗舰店，且拥有 100 家线上合作伙伴。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2018
      </div>

      <div class="milestone_white2019" data-tooltip="2019年：签约 9 球世界冠军刘海涛，启用秦皇岛海关办公区，同时璟点台球杆产品正式投产。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2019
      </div>

      <div class="milestone_white2020" data-tooltip="2020年：正式生产销售璟点品牌台球桌，璟点碳纤维复合材料产品正式投产，协助孵化小怪兽品牌，全面推出璟点全国级别系列赛事，且北京新璟体体育传媒有限公司成立。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2020
      </div>

      <div class="milestone_white2021" data-tooltip="2021年：投资成立北京璟点聚科科技有限公司，同时投资九剑创展台球桌石板工厂。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2021
      </div>

      <div class="milestone_white2022" data-tooltip="2022年：东戴河璟点集团台球产业落地，布局三家自有工厂（复合材料、台球杆、台球桌），搬迁至璟点集团台球产业园，且整合三家石板、石材厂并成立联硕石材厂。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2022
      </div>

      <div class="milestone_white2023" data-tooltip="2023年：璟点集团台球产业园扩建至 8 万余平米，璟点台球桌签约潘晓婷，同时中国台球协会官方宣布璟点承办 CBSA 中式台球中国公开赛。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2023
      </div>

      <div class="milestone_white2024" data-tooltip="2024年：成功举办第一届 CBSA 中式台球中国公开赛总决赛，璟点文体旅游项目与东戴河管委会签订正式协议，璟点品牌成为央视国潮品牌馆上榜品牌，且璟点台球桌及台球器材远销海外。">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2024
      </div>

      <div class="milestone_white2025" data-tooltip="2025年：美好前璟 点亮热爱">
        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />2025
      </div>

      <!-- 未来模块 -->
<!--      <div class="milestone_future">-->
<!--        <img src="@/assets/img/home/milestone/line_logo.png" alt="" class="logo_line" />-->
<!--        美好前璟 <br/>点亮热爱-->
<!--      </div>-->

      <!-- 其他固定元素 -->
      <div class="milestone_2024">2026</div>
      <div class="milestone_straight"></div>
      <div class="milestone_JingDian">璟点台球集团 全面启动全球化征程</div>
    </div>
  </div>
</template>

<script>

import '@/assets/css/milestone.css';
export default {
  name: 'Milestone'
}
</script>

<style lang="scss" scoped>

</style>
